import React, {useContext} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {Card, CardContent, CardHeader, Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import {TicketDetails} from "./TicketDetails";
import AccordionFaq from "../../faq/AccordionFaq";
import {FaqContext} from "../CallcenterTicketForm";
import {useFormContext} from "react-hook-form";
import {categoriesV2} from "../../../../utils/dictionaries/Categories";
import clsx from "clsx";

const DettaglioCard = ({handleKeyDown, tags, setTags}) => {
	const classes = BaseStyle();
	const faqContext = useContext(FaqContext);
	const {watch} = useFormContext();
	
	return (
		<React.Fragment>
			<Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Dettaglio ticket</b></Typography>}
					subheader={"Indica a quale categoria appartiene il ticket e scrivi nella nota la richiesta del paziente. " +
					"Premendo Ctrl+Invio nel campo note la chiamata verrà automaticamente registrata e trasmessa. I campi aggiuntivi che vedi non sono obbligatori, sfruttali qualora ti servisse indicare altre informazioni ai livelli successivi."}
				/>
				<CardContent style={{flexGrow: 1}}>
					<Grid container spacing={3}>
						<TicketDetails handleKeyDown={handleKeyDown} mail={true} tags={tags} setTags={setTags}/>
						{
							watch("dettaglioRichiesta") !== "" &&
							<Grid item xs={12}>
								{
									faqContext.state.loadingSearchFaq ? "...sto caricando le faq..." :
										faqContext.state.errorSearchFaq !== "" ? "Ops, errore" :
											faqContext.state.faqs.filter(item => watch("dettaglioRichiesta")?.split(" ").filter(wordLength => wordLength.length >= 4)
													.some(word => item?.keywords?.split(",").filter(wordItemLength => wordItemLength.length >= 4)
															.some(tag => word.toUpperCase().includes(tag.toUpperCase()) || tag.toUpperCase().includes(word.toUpperCase())) ||
														item?.domanda?.split(" ").filter(wordQuestionLength => wordQuestionLength.length >= 4)
															.some(tag => word.toUpperCase().includes(tag.toUpperCase()) || tag.toUpperCase().includes(word.toUpperCase()))))
												.map((faq, index) => {
													return (
														<AccordionFaq key={index} domanda={faq.domanda} risposta={faq.risposta}/>
													)
												})
								}
							</Grid>
						}
						{
							watch("categoria") !== "" &&
							<Grid item xs={12}>
								{
									faqContext.state.loadingSearchFaq ? "...sto caricando le faq..." :
										faqContext.state.errorSearchFaq !== "" ? "Ops, errore" :
											faqContext.state.faqs.filter(f => f.categoria === categoriesV2[watch("categoria")]?.label).map((faq, index) => {
												return (
													<AccordionFaq key={index} domanda={faq.domanda} risposta={faq.risposta}/>
												)
											})
								}
							</Grid>
						}
					</Grid>
				</CardContent>
			</Card>
		</React.Fragment>
	);
};

export default React.memo(DettaglioCard)
